import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Container,
  Dialog,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import styles from "./clientsAmountcreditsDialogStyles";
import CreditsConfirmationDialog from "../ClientsConfirmationCreditsDialog";

ClientsAmountCreditsDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function ClientsAmountCreditsDialog({ onClose, open, action, idUser, user, fetchClientCredits }) {
  const [credits, setCredits] = useState(0);
  const [commentary, setCommentary] = useState("");

  const handleCreditsChange = (event) => {
    setCredits(event.target.value);
  };
  
  const handleCommentaryChange = (event) => {
    setCommentary(event.target.value);
  };

  const [openDialog, setOpenDialog] = useState(null);

  const handleDialogOpen = (dialogName, action) => {
    setOpenDialog(dialogName);
  };

  const handleLocalDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    onClose();
  };

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setCredits(0);
    setCommentary('');
    setOpenDialog(null);
    onClose();
  };
  
  const handleContinueClick = (event, reason) => {
    if (credits === null || credits === '' || credits === 0) {
      return;
    }
    handleDialogOpen("CreditsConfirmationDialog");
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: styles.dialog }}
    >
      <Container style={styles.mainContainer}>
        <Typography component="div" variant="h5" style={styles.title}>
          {action} créditos
        </Typography>
        <Typography component="div" variant="body1" >
          Ingresa la cantidad de créditos
        </Typography>
        
        { action === 'Remover' && <Typography component="div" variant="body1">
          Los créditos máximos para remover son <strong>{user?.actual_credits}</strong>
        </Typography>}
        
        <Container style={styles.subtitle}></Container>

        <TextField
          id="standard-basic"
          label="Número de créditos"
          variant="standard"
          onChange={handleCreditsChange}
          type="number"
          InputProps={{
            inputProps: { min: 0 },
            startAdornment: (
              <InputAdornment position="start">$</InputAdornment>
            ),
          }}
          sx={styles.textField}
        />

        <Container sx={styles.divider}></Container>
        
        <TextField
          id="standard-basic"
          label="Comentario"
          variant="standard"
          onChange={handleCommentaryChange}
          type="text"
          multiline
          inputProps={{ maxLength: 50 }}
          sx={styles.textField}
        />

        <Container style={styles.buttonsContainer}>
          <Button
            variant="standard"
            color="primary"
            onClick={handleLocalDialogClose}
            style={styles.cancelButton}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handleContinueClick();
            }}
            disabled={
              credits === "" ||
              credits === "0" ||
              credits <= 0 ||
              credits.toString().includes('.') ||
              !(/^\d*$/.test(credits)) ||
              ( action === 'Reducción' && parseInt(credits) > user?.actual_credits)
            }
            sx={credits !== '' || credits !== '0' ? styles.activeButton : styles.inactiveButton}
          >
            Continuar
          </Button>
        </Container>
      </Container>

      <CreditsConfirmationDialog 
        open={openDialog === "CreditsConfirmationDialog"}
        action={action}
        name={user?.fullname}
        idUser={idUser}
        commentary={commentary}
        fetchClientCredits={fetchClientCredits}
        onClose={handleDialogClose}
        credits={credits}
        setCommentary={setCommentary}
        setCredits={setCredits}
      />
    </Dialog>
  );
}
